import React, { memo } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined'

import sx from './styles'

const OnedaySuccessLead = ({
  name = 'JESÚS',
  carModel = 'Toyota RAV4 2021',
  date = 'Jueves, 26 de Marzo, 2026',
  time = '10:00 AM',
  branch = 'ClikAuto La Capilla',
}) => {
  const firstName = name.split(' ')[0]

  return (
    <Container
      maxWidth="md"
      sx={sx.container}
    >
      <Typography
        variant="h1"
        sx={sx.mainTitle}
      >
        ¡GRACIAS
        {' '}
        {firstName.toUpperCase()}
        !
      </Typography>
      <Typography
        variant="h2"
        sx={sx.subtitle}
      >
        La cita de inspección para tu
        {' '}
        {carModel}
        {' '}
        ha sido confirmada con éxito
      </Typography>

      <Box sx={sx.card}>
        {/* SECCIÓN 1: Cita Confirmada */}
        <Typography sx={sx.sectionTitle}>
          CITA CONFIRMADA
        </Typography>

        <Box sx={sx.infoRow}>
          <CalendarTodayIcon sx={sx.icon} />
          <Typography variant="body1">
            <strong>Fecha:</strong>
            {' '}
            {date}
          </Typography>
        </Box>

        <Box sx={sx.infoRow}>
          <AccessTimeIcon sx={sx.icon} />
          <Typography variant="body1">
            <strong>Hora:</strong>
            {' '}
            {time}
          </Typography>
        </Box>

        <Box sx={sx.infoRow}>
          <LocationOnOutlinedIcon sx={sx.icon} />
          <Typography variant="body1">
            <strong>Sucursal:</strong>
            {' '}
            {branch}
          </Typography>
        </Box>

        {/* SECCIÓN 2: Próximos Pasos */}
        <Typography sx={{ ...sx.sectionTitle, mt: 4 }}>
          PRÓXIMOS PASOS
        </Typography>

        <Box sx={sx.stepRow}>
          <Box sx={sx.stepCircle}>1</Box>
          <Typography variant="body1">Prepara tu documentación</Typography>
        </Box>

        <Box sx={sx.stepRow}>
          <Box sx={sx.stepCircle}>2</Box>
          <Typography variant="body1">Mantén tu auto limpio para la inspección</Typography>
        </Box>

        <Box sx={sx.stepRow}>
          <Box sx={sx.stepCircle}>3</Box>
          <Typography variant="body1">¡Nuestro equipo te espera en la sucursal!</Typography>
        </Box>

        {/* Footer Card */}
        <Typography sx={sx.footerText}>
          Te hemos enviado un correo de confirmación con todos estos detalles
        </Typography>
      </Box>
    </Container>
  )
}

export default memo(OnedaySuccessLead)
